import getENV from "../../../../util/getENV";
import useSmartContract from "../../useSmartContract";

export default function useSkeleDrop() {
    //console.log('>>> useSkeleDrop')
    const { modules: { drop: { contract } } } = getENV();
    const { contract: drop } = useSmartContract(contract);
    return { drop }

}